import React, { useState } from "react";
import { StyledSwipeableDrawer, StyledTypography } from "../../../../../../styled-mui";
import MobileMenuWrapper from "../../MobileMenuWrapper";
import { Box, Stack } from "@mui/material";
import { CLICK } from "../../../../../../_foundation/constants/gtm";
import AsyncCall from "../../../../../../_foundation/gtm/async.service";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import MobileProductsLevel3Menu from "./MobileProductsLevel3Menu";

interface Props {
  open: boolean;
  entireMenuCloseHandler: () => any;
  closeCurrentMenu: () => any;
  levelOneCat: Record<string, any> | null;
  filteredLinksByCatL1: Record<string, any>[];
}

const MobileProductsLevel2Menu: React.FC<Props> = ({
  open,
  entireMenuCloseHandler,
  closeCurrentMenu,
  levelOneCat,
  filteredLinksByCatL1,
}) => {
  const levelTwoCategoryChildren = levelOneCat?.children || [];
  const [selectedLevelTwoCat, setSelectedLevelTwoCat] = useState<Record<string, any> | null>(null);

  const closeProduitsLevel2Menu = () => {
    setSelectedLevelTwoCat(null);
    closeCurrentMenu();
  };

  const closeLevel3CategoryMenu = () => {
    setSelectedLevelTwoCat(null);
  };

  const onCatItemClick = (catItem: Record<string, any>) => {
    AsyncCall.sendClick(CLICK.NAV, {
      navlink: catItem?.name + "_" + catItem?.seo?.href,
    });
    setSelectedLevelTwoCat(catItem || null); // enables level three category menu
  };

  return (
    <>
      <StyledSwipeableDrawer
        anchor="left"
        open={open}
        onClose={closeProduitsLevel2Menu}
        onOpen={() => null}
        className="child-drawer header-menu-level3 mobile-produits-level2-menu">
        <MobileMenuWrapper
          title={levelOneCat?.name || ""}
          isASubMenu
          entireMenuCloseHandler={entireMenuCloseHandler}
          closeCurrentMenu={closeProduitsLevel2Menu}>
          {levelTwoCategoryChildren.map((catItem: Record<string, any>, index: number) => (
            <Box
              key={catItem?.identifier}
              onClick={() => onCatItemClick(catItem)}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                padding: "16px 12px",
                borderBottom: "1px solid rgba(0, 0, 0, 0.11)",
              }}>
              <Stack direction="row" justifyContent="space-between" width="100%">
                <StyledTypography
                  variant="body1"
                  component="p"
                  style={{ fontSize: "15px", fontWeight: "600", lineHeight: "20px" }}>
                  {catItem?.name || ""}
                </StyledTypography>
                <ChevronRightIcon sx={{ fontSize: "20px", color: "black" }} />
              </Stack>
            </Box>
          ))}
        </MobileMenuWrapper>
      </StyledSwipeableDrawer>

      {/* LEVEL 3 CATEGORY PAGE, using "open" state to prevent unnecessary DOM size */}
      {open && (
        <MobileProductsLevel3Menu
          levelOneCat={levelOneCat}
          levelTwoCat={selectedLevelTwoCat}
          open={selectedLevelTwoCat !== null}
          entireMenuCloseHandler={entireMenuCloseHandler}
          closeCurrentMenu={closeLevel3CategoryMenu}
          filteredLinksByCatL1={filteredLinksByCatL1}
        />
      )}
    </>
  );
};

export default MobileProductsLevel2Menu;
